import { ApiClientFactory } from "common/middleware/api.client-factory";

export const getCode = async (code: string) => {
  const client = await ApiClientFactory.getQrCodeClient(false);
  return await client.getQrCode(code);
}
